import {useAnalytics} from '@/hooks/useAnalytics';
import type {
  GetNextBuyflowStepResponse,
  PreconfiguredProductWidget,
  ProductWidgetType,
} from '@/lib/TypesOpenApi';
import {persist} from '@/lib/vatio-persistence';
import {useCallback} from 'react';
import {proxy, useSnapshot} from 'valtio';
import {
  type StepWidgetStore,
  StepsPath,
  stepsMap,
} from '../routing/StepsRouting';
import {useWidget} from '../routing/StepsWizardContext';
import {getProductWidget} from './widget';

const widget = stepsMap.PRECONFIG.store;

export interface PreconfigPageWidget {
  widget: StepWidgetStore;
  content?: GetNextBuyflowStepResponse;
  preconfigWidget: PreconfiguredProductWidget;
}

export const preconfigWidget = proxy<PreconfigPageWidget>({
  widget,
  get content() {
    return this.widget.content;
  },
  get preconfigWidget() {
    return getProductWidget(
      this.content,
      'preconfiguredProductWidget',
    ) as PreconfiguredProductWidget;
  },
});

export const usePreconfigWidget = () =>
  useWidget(StepsPath.Preconfig, preconfigWidget);

export type PreconfigState = {
  [key in ProductWidgetType]?: boolean;
};

// if add any new field, add the new field to the below reset function also
export const store = persist<PreconfigState>(StepsPath.Preconfig, {});

export const resetPreconfigState = () => {
  // TODO: implement resetPhoneQuestionnaireState if needed
};

export const usePreconfigState = () => useSnapshot(store);

const getAnalyticsOptionNameByProductType = (
  productType: ProductWidgetType,
): string | undefined => {
  switch (productType) {
    case 'PHONE_PRODUCT':
      return 'phone selection';
    case 'STREAMING_PRODUCT':
      return 'tv selection';
  }
};

/** Remove product from enabled list if it exists, or add if not */
export const useToggleProduct = () => {
  const analytics = useAnalytics();

  return useCallback(
    (product: ProductWidgetType) => {
      store[product] = !store[product];

      const optionName = getAnalyticsOptionNameByProductType(product);

      if (optionName) {
        analytics.trackPreconfigCardSelection(
          optionName,
          store[product] ? 'on' : 'off',
        );
      }
    },
    [analytics],
  );
};
